import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { injectIntl } from 'react-intl';
import { isNotEmpty, isColorBright, RGB_2_HEX } from '../../../lib/ep';

import ActionButton from '../../builder/ActionButton';
import Loader from '../../builder/Loader';
import ResponsiveYouTube from '../../builder/ResponsiveYouTube.js';

import VideoEmbed from '../../front/VideoEmbed';
import LeveledHTMLText from '../helpers/LeveledHTMLText.js';

const StoryStageContents = ({ stage, ...props }) => {
	const is_builder = props?.is_builder ?? false;
	const success_link = useRef(false);

	const [ participation_res, setParticipationRes ] = useState(false);
	const [ secondary_button, setSecondaryButton ] = useState(false);

	const main_image = (isNotEmpty(stage, 'main_image')) ? stage.full_main_image : false;
	const main_video = (isNotEmpty(stage, 'main_video') && isNotEmpty(stage.main_video, 'full_url')) ? stage.main_video : false;

	const main_video_portrait = (main_video !== false && (stage?.main_video_portrait ?? false)) ? true : false;

	const bg_color = stage?.bg_color ?? 'rgba(255, 255, 255, 0.5)';
	const text_color = stage?.text_color ?? '#FFFFFF';
	const highlight_color = stage?.highlight_color ?? '#000000';

	let content_styles = {
		backgroundColor:bg_color,
	};
	if(isNotEmpty(stage, 'bg_image')) content_styles.backgroundImage = `url(${stage.full_bg_image})`;

	let container_classes = ['story_c'];
	const bg_padding = (stage.bg_padding != undefined) ? stage.bg_padding : 'normal';
	switch(bg_padding) {
		case '0':
		default:
			container_classes.push('is_not_padded');
			break;

		case 'small':
		case 'normal':
		case 'big':
			container_classes.push(`is_${bg_padding}_padded`);
			break;
	}

	let description_with_highlight = false;
	if(stage.main_description != undefined && stage.main_description != "") {
		description_with_highlight = stage.main_description.replaceAll(/(<(h[1|2|3|4|5|6]|p)[^>]*>)(.*?)(<\/\2>)/gmi, "\$1<span class='highlight_bg' style='color:" + text_color + "; background-color:" + highlight_color + ";'>\$3</span>\$4");
	}

	const participate = (cb) => {
		$.post(`/promotions/participate/${stage.promotion_id}/${stage.id}`, { ticket:props.ticket }, (res) => {
			if(res.status) {
				setTimeout(() => {
					setParticipationRes(res);
				}, 1000);
				if(cb != undefined) cb();
			} else {
				if(res.url != undefined) {
					window.location.href = res.url;
				}
			}
		}, 'JSON');
	};

	useEffect(() => {
		if(is_builder) return;
		participate();
	}, []);

	/* BUTTON OPTIONS - ini */
	const button_color = (stage.button_color != undefined) ? stage.button_color : '#FFFFFF';
	let button_icon_color = 'white';
	let loader_color = '#FFFFFF';
	if(isColorBright(RGB_2_HEX(button_color))) {
		button_icon_color = 'black';
		loader_color = '#000000';
	}
	let button_label = (stage.button_label != undefined && stage.button_label != "") ? stage.button_label : null;
	let button_props = {
		autotranslate:false,
		style:{ background:button_color },
	};
	let button_classes = ['variableButton', `${button_icon_color}Icon`, `${button_icon_color}Color`];
	let button_icon = (is_builder || participation_res !== false) ? 'knk-arrow-r-big' : false;

	let has_won_a_prize = false;
	let has_external_button = false;
	if(!is_builder && participation_res !== false) {
		success_link.current = participation_res.url;
		let button_link = success_link.current;
		
		has_won_a_prize = participation_res.prize != undefined && participation_res.prize !== false ? true : false;
		has_external_button = stage.button_target != undefined && stage.button_target == 'external' && stage.button_url != undefined && stage.button_url.indexOf("http") > -1 ? true : false;
		
		if(has_external_button) {
			button_link = stage.button_url;
			button_props._target = '_blank';
			button_props.onClick = () => {
				setTimeout(() => {
					setSecondaryButton(true);
				});
			};
		} else if(has_won_a_prize) {
			//button_label = "You've won a prize";
			//button_icon = 'knk-winners';
		}
		button_props._href = button_link;
	}

	if(button_icon !== false) button_classes.push(button_icon);
	if(button_label != null && button_label != "" && (is_builder || participation_res !== false)) button_classes.push('with_label');

	button_props._fullclass = button_classes.join(" ");
	/* BUTTON OPTIONS - end */
	
	return (
		<aside class="gui_story_alike is_fullscreen relative_to_container">
			<div class="story_stage awesome">
				<img src={`${window.cdn_url}img/blank_108x192.png`} alt="" />

				<div class="story_contents is_fullscreen relative_to_container" style={content_styles}>
					{(main_video && main_video_portrait) && (
						<ResponsiveYouTube
							videoId={main_video.video_id}
							is_portrait={true}
							opts={{ autoplay:(!is_builder) ? 1 : 0 }}
							_class={{ other:'is_fullscreen relative_to_container' }}
						/>
					)}

					<div class={container_classes.join(" ")}>
						<div>
							{(main_image || main_video) && (
								<div class="story_media">
									{(!main_video && main_image) && (
										<img src={main_image} alt="" style={{maxWidth:'100%'}} />
									)}

									{(main_video && !main_video_portrait) && (
										<VideoEmbed
											video_url={main_video.full_url}
											video_thumb={main_video.image}
										/>
										// <ResponsiveYouTube
										// 	videoId={main_video.video_id}
										// 	is_portrait={false}
										// 	thumbnail={main_video.image}
										// />
									)}
								</div>
							)}

							{(description_with_highlight !== false && (stage?.main_video_portrait ?? false) === false) && (
								<LeveledHTMLText
									_class={{ other:'story_description' }}
									style={{ color:text_color }}
								>{description_with_highlight}</LeveledHTMLText>
							)}
						</div>
					</div>

					<div class="story_cta">
						{(!secondary_button) && (
							<ActionButton
								{...button_props}
							>{(is_builder || participation_res !== false) ? button_label : <Loader color={loader_color} />}</ActionButton>
						)}

						{(!is_builder && secondary_button) && (
							<ActionButton
								_fullclass={`with_label ${button_classes.join(" ")}`}
								style={{ backgroundColor:button_color }}
								_href={success_link.current}
							>Finalize</ActionButton>
						)}
					</div>
				</div>
			</div>
		</aside>
	)
};

const StoryStage = (props) => {
	const is_builder = (props.is_builder != undefined) ? props.is_builder : false;

	if(is_builder) {
		return (
			<StoryStageContents {...props} />
		)
	}

	let element = document.getElementById('story_modal_root');
	if(element == null) {
		element = document.createElement('div');
		element.id = 'story_modal_root';
		document.body.appendChild(element);
		element = document.getElementById('story_modal_root');
	}

	return ReactDOM.createPortal(
		<StoryStageContents {...props} />,
		element,
	);
};

export default injectIntl(StoryStage);